import { ShallowRef } from 'vue';
import { FeedLiveItem } from '@/models/feedLive';
import eventBus from '@/services/eventBus';
import { FeedPregameItem } from '@/models/feedPregame';
import { EventName, Line } from '@/constants';

export function useBetsChangedHandler(items: ShallowRef<FeedLiveItem[] | FeedPregameItem[]>) {
    const handler = (payload: any) => {
        const { customEventIds } = payload as { customEventIds: string[]; betIds: string[] };
        for (const item of items.value) {
            if (item.line.value === Line.Main && customEventIds.includes(item.customEventId.value)) {
                console.log(`Bets were changed for event ${item.customEventId.value}, recalculate position`);
                item.calculatePosition();
            }
        }
    };

    eventBus.on(EventName.BetsChanged, handler);
}
